import html2canvas from 'html2canvas'

export const useGenerateFiles = () => {
    const getImageBase64Dashboards = async (targetElementId: string) => {
        const element = document.getElementById(targetElementId)

        if (!element) {
            console.error(`Element with ID '${targetElementId}' not found.`)
            return
        }

        try {
            const canvasOptions = {
                scale: 2,
                useCORS: true
            }

            const canvas = await html2canvas(element, canvasOptions)
            const imageBase64 = canvas.toDataURL('image/png')

            return imageBase64
        } catch (error) {
            throw new Error('fail generate imagebase64')
        }
    }

    return {
        getImageBase64Dashboards
    }
}
